import { Injectable, inject } from '@angular/core';
import { EmployeeApiService } from '@data-terminal/feature-workstation-details/services/employee-api/employee-api.service';
import { Employee, UserLoginTimestamps } from '@data-terminal/shared-models/employee';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class EmployeeService {
    private readonly employeeApiService = inject(EmployeeApiService);

    public fetchUserMachineLogins(userId: string): Observable<UserLoginTimestamps[]> {
        return this.employeeApiService.getUserMachineLogins(userId);
    }

    public fetchEmployees(): Observable<Employee[]> {
        return this.employeeApiService.getEmployees();
    }
}
